export default {
    url: '/budget',
    template: '<reports-budget classifiers="vm.classifiers" sites="vm.sites"/>',
    resolve: {
        sites: (SiteResource) => SiteResource.query({ reportUserCourseProgressSites: true }).$promise
    },
    controller (classifiers, sites) {
        this.classifiers = classifiers;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/budget/index.js